import { QueryKey } from 'react-query';

export const queryKeys = {
  all: ['publicFeatureFlags'],
  byShop: (payload: { shopId: string; flags: string[] }): QueryKey => [...queryKeys.all, payload.shopId, payload.flags],
};
